<template>
  <el-container class="container">
    <el-header height="48px" style="padding: 0px">
      <header-bar @collapse-sidebar="collapse" :refreshUser="isRefreshUser" />
    </el-header>
    <el-container>
      <aside-bar :collapse="isCopllase" />
      <el-main style="padding: 24px">
        <router-view @login="login"></router-view>
      </el-main>
    </el-container>
    <el-dialog v-model="dialogLoginVisible" center="true" show-close="false">
      <login @is-show="completedLogin" />
    </el-dialog>
    <el-footer>
    <footer-bar></footer-bar>
  </el-footer>
  </el-container>
 
</template>
<script>
import HeaderBar from "./headerBar";
import AsideBar from "./asideBar";
// import PageHeader from "./pageHeader";
import { ref } from "vue";
import Login from "@/views/login";
import FooterBar from "./footerBar.vue";

export default {
  name: "Layout",

  components: {
    HeaderBar,
    AsideBar,
    Login,
    FooterBar,
  },

  setup() {
    let isCopllase = ref(false);
    let dialogLoginVisible = ref(false);
    let isRefreshUser = ref(false);
    function collapse(isCopllasePara) {
      isCopllase.value = isCopllasePara;
    }
    // 登录
    function completedLogin() {
      dialogLoginVisible.value = false;
      isRefreshUser.value = true;
    }
    // 登录
    function login() {
      dialogLoginVisible.value = true;
    }
    return {
      isCopllase,
      collapse,
      dialogLoginVisible,
      login,
      completedLogin,
      isRefreshUser,
    };
  },
};
</script>
<style lang="scss" scoped>
.container {
  background-color: #f0f2f5;
  width: 100%;
  // height: 100vh;
}
.asider-container {
  width: 208px;
  height: 100%;
  background-color: #fff;
}
// /deep/ .el-dialog{
//   height: 400px;
//   width: 400px;
// }
</style>
